(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["prohaar-store-app"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const init = () => {
    const nav=document.getElementById('phapp-nav');
    if(!nav || document.documentElement.hasAttribute('data-phapp-ready'))return;
    document.documentElement.setAttribute('data-phapp-ready','');
    const media=matchMedia('(max-width:1000px)'), config=JSON.parse(document.getElementById('kia-config').textContent);
    const menu=document.getElementById('ph-mobile-menu'),cart=document.getElementById('cart'),search=document.getElementById('search'),sticky=document.getElementById('sticky-add-to-cart'),bar=document.getElementById('nav-top');
    const originalSearch=document.querySelector('#header-inner .search-compact[aria-controls="search"]');
    const update=()=>{
      const menuOpen=!!menu?.open,cartOpen=cart?.getAttribute('aria-hidden')==='false',searchOpen=document.documentElement.classList.contains('search-compact-active')||document.documentElement.classList.contains('search-full');
      nav.querySelector('[data-phapp-menu]')?.setAttribute('aria-expanded',String(menuOpen));
      nav.querySelector('[data-phapp-search]')?.setAttribute('aria-expanded',String(searchOpen));
      nav.querySelector('[data-panel="cart"]')?.setAttribute('aria-expanded',String(cartOpen));
      document.body.classList.toggle('phapp-overlay',menuOpen||cartOpen);
      const visible=media.matches&&sticky&&sticky.getAttribute('aria-hidden')==='false'&&!sticky.classList.contains('align-top');
      const height=visible?Math.ceil(sticky.getBoundingClientRect().height):0;
      document.body.classList.toggle('phapp-buybar',!!height);document.body.style.setProperty('--phapp-extra',height+'px');
      const count=(document.getElementById('cart-count')?.textContent||'0').trim(),badge=nav.querySelector('[data-phapp-count]');
      if(badge.textContent!==count)badge.textContent=count;badge.hidden=Number(count)===0;
      const cartButton=nav.querySelector('[data-panel="cart"]');cartButton.setAttribute('aria-label',config.mobile.cart+(Number(count)>0?' ('+count+')':''));
    };
    const responsive=()=>{document.body.classList.toggle('phapp-mobile',media.matches);if(bar)document.body.style.setProperty('--phapp-info',media.matches?bar.getBoundingClientRect().height+'px':'0px');update();};
    const keyboard=()=>{const editing=document.activeElement?.matches('input,textarea,select,[contenteditable=true]');document.body.classList.toggle('phapp-keyboard',media.matches&&editing&&(window.visualViewport?.height||innerHeight)<innerHeight*.75);};
    const language=document.querySelector('#nav-user .lang>a.toggle');if(language)language.dataset.phappIso=config.iso.toUpperCase();
    nav.querySelector('[data-phapp-search]')?.addEventListener('click',event=>{if(!originalSearch)return;event.preventDefault();originalSearch.click();update();});
    if(search){const close=document.createElement('button');close.type='button';close.className='phapp-search-close';close.textContent=config.mobile.close;close.addEventListener('click',()=>{originalSearch?.click();nav.querySelector('[data-phapp-search]')?.focus({preventScroll:true});});search.append(close);document.addEventListener('keydown',e=>{if(e.key==='Escape'&&media.matches&&document.documentElement.classList.contains('search-compact-active')){e.preventDefault();originalSearch?.click();nav.querySelector('[data-phapp-search]')?.focus({preventScroll:true});}});}
    const countSource=document.getElementById('cart-count');if(countSource)new MutationObserver(update).observe(countSource,{childList:true,characterData:true,subtree:true});
    [menu,cart,sticky,document.documentElement].filter(Boolean).forEach(n=>new MutationObserver(update).observe(n,{attributes:true,attributeFilter:['open','class','aria-hidden']}));
    if(sticky)new ResizeObserver(update).observe(sticky);if(bar)new ResizeObserver(responsive).observe(bar);
    function whatsapp(){const host=document.querySelector('gty-whatsapp-chat-button'),root=host?.shadowRoot;if(!root||root.querySelector('#phapp-whatsapp'))return;const style=document.createElement('style');style.id='phapp-whatsapp';style.textContent='@media(max-width:1000px){.gty-wacb-wrapper{left:auto!important;right:16px!important;bottom:calc(78px + env(safe-area-inset-bottom,0px) + var(--phapp-extra,0px))!important;z-index:80!important}.gty-wacb-button{width:46px!important;height:46px!important}.gty-wacb-button:focus-visible{outline:3px solid #193b64;outline-offset:3px}.gty-wacb-button svg{width:26px!important;height:26px!important}}';root.append(style);const link=root.querySelector('a.gty-wacb-button');if(link)link.setAttribute('aria-label',config.mobile.whatsapp);}
    whatsapp();customElements.whenDefined('gty-whatsapp-chat-button').then(whatsapp);new MutationObserver(whatsapp).observe(document.body,{childList:true});
    media.addEventListener('change',responsive);window.visualViewport?.addEventListener('resize',keyboard);document.addEventListener('focusin',keyboard);document.addEventListener('focusout',keyboard);window.addEventListener('pageshow',responsive);responsive();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

(() => {
  'use strict';
  const config = document.getElementById('kia-config');
  if (!config || document.documentElement.hasAttribute('data-kia-ready')) return;
  document.documentElement.setAttribute('data-kia-ready', '1');
  const c = JSON.parse(config.textContent), w = c.words;
  let pending = null, sequence = 0, queued = false;
  const standalone = matchMedia('(display-mode: standalone)');
  const isInstalled = () => standalone.matches || navigator.standalone === true;
  const syncInstalled = () => document.documentElement.toggleAttribute('data-kia-installed', isInstalled());
  syncInstalled();
  if (standalone.addEventListener) standalone.addEventListener('change', syncInstalled);
  else if (standalone.addListener) standalone.addListener(syncInstalled);
  window.addEventListener('beforeinstallprompt', e => { e.preventDefault(); pending = e; document.documentElement.setAttribute('data-kia-install-ready', ''); });
  window.addEventListener('appinstalled', () => { pending = null; document.documentElement.removeAttribute('data-kia-install-ready'); document.documentElement.setAttribute('data-kia-installed', ''); });
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; };
  const icon = name => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    const path = document.createElementNS(svg.namespaceURI, 'path');
    path.setAttribute('d', { install:'M12 3v11m-4-4 4 4 4-4M4 15v5h16v-5', book:'M12 5v16M3 3h5a4 4 0 0 1 4 2 4 4 0 0 1 4-2h5v16h-5a4 4 0 0 0-4 2 4 4 0 0 0-4-2H3z', arrow:'m9 5 7 7-7 7' }[name]);
    svg.append(path); return svg;
  };
  function panel(menu = false) {
    const box = el('section', 'kia-install' + (menu ? ' kia-install--menu' : ''));
    box.style.setProperty('--kia-accent', c.accent); box.style.setProperty('--kia-paper', c.paper);
    box.style.setProperty('--kia-ink', c.ink || '#352e35');
    box.style.setProperty('--kia-button-ink', c.buttonInk || '#ffffff');
    const heading = 'kia-title-' + (++sequence);
    box.setAttribute('aria-labelledby', heading);
    const intro = el('div', 'kia-intro'), image = el('img');
    image.src = c.icon; image.alt = c.name; image.width = 64; image.height = 64; image.decoding = 'async';
    const copy = el('div'), title = el('h2', 'kia-title', w.title), text = el('p', 'kia-text', w.text.replace('{name}', c.name));
    title.id = heading; copy.append(title, text); intro.append(image, copy);
    const button = el('button', 'kia-button'); button.type = 'button'; button.dataset.kiaInstall = ''; button.append(icon('install'), el('span', '', w.install));
    box.append(intro, button); return box;
  }
  document.addEventListener('click', async e => {
    const button = e.target instanceof Element && e.target.closest('[data-kia-install]');
    if (!button) return;
    if (!pending) return;
    const event = pending; pending = null; button.disabled = true;
    try { await event.prompt(); await event.userChoice; }
    catch (_) {}
    finally { document.documentElement.removeAttribute('data-kia-install-ready'); button.disabled = false; }
  });
  function magazineLink(root) {
    if (c.adapter === 'myruna') return null;
    const links = [...root.querySelectorAll('a[href]'), ...document.querySelectorAll('header a[href],#header a[href]')];
    return links.find(a => !a.closest('.kia-menu-extras') && (/magaz|journal|blogs\/inspiratie|tvcmsblog\/(?:archive|main)|hiblog/i.test(a.href) || /magaz|journal|inspiratie\s*&\s*advies/i.test(a.textContent))) || null;
  }
  function enhanceMenu() {
    queued = false;
    let root, before = null;
    if (c.adapter === 'intiem') {
      const services = document.querySelector('#ic-mobile-menu .icmm-service');
      if (!services) return;
      root = services.parentElement; before = services;
    } else if (c.adapter === 'beauty') {
      const services = document.querySelector('#dbux-menu .dbux-services');
      if (!services) return;
      root = services.parentElement; before = services;
    } else if (c.adapter === 'cosmetics') {
      const services = document.querySelector('#diana-mobile-menu .dux-services,#diana-mobile-menu .dmm-services');
      if (!services) return;
      root = services.parentElement; before = services;
    } else if (c.adapter === 'kiljano') {
      root = document.querySelector('#kj-mobile-menu .kj-drawer-content');
      before = root && root.querySelector('.kj-drawer-utility');
    } else if (c.adapter === 'lumervi') {
      root = document.querySelector('#mobileMenu [data-lum-mobile-home]');
      before = root && root.querySelector('.lum-mobile__service');
      const contact = root && [...root.querySelectorAll('.lum-mobile__quick:not(.lum-mobile__service) a')].find(a => a.querySelector('.material-icons'));
      if (contact && before) before.prepend(contact);
    } else if (c.adapter === 'artavio') {
      root = document.querySelector('#av-menu .av-mobile-navigation');
      before = root && root.querySelector('.av-mobile-service-link');
    } else if (c.adapter === 'myruna') {
      root = document.querySelector('.mu-mobile-content');
      before = root && root.querySelector('a[href*="/PAGE-CONTACT/"]');
    }
    else if (c.adapter === 'mirevie') {
      root = document.querySelector('[data-mobile-nav-root] .mobile-nav__scroll');
      before = root && root.querySelector('.mobile-nav__utilities');
    } else if (c.adapter === 'prohaar') {
      const services = document.querySelector('#ph-mobile-menu .phm-services');
      if (!services) return;
      root = services.parentElement; before = services;
    }
    if (!root || root.querySelector(':scope > .kia-menu-extras')) return;
    const extras = el('div', 'kia-menu-extras'); extras.dataset.kiaMenu = ''; extras.style.setProperty('--kia-accent', c.accent); extras.style.setProperty('--kia-paper', c.paper); extras.style.setProperty('--kia-ink', c.ink || '#352e35');
    const existingTile = root.querySelector('.icmm-magazine-card');
    const original = existingTile ? null : magazineLink(root);
    if (original) {
      const a = root.contains(original) ? original : el('a');
      if (a !== original) a.href = original.href;
      a.classList.add('kia-magazine-card');
      const copy = el('span', 'kia-magazine-copy'); copy.append(el('strong', '', w.magazine), el('span', '', w.magazineText));
      if (c.magazineImage) {
        const photo = el('img', 'kia-magazine-photo'); photo.src = c.magazineImage; photo.alt = ''; photo.width = 768; photo.height = 512; photo.loading = 'lazy'; photo.decoding = 'async';
        a.classList.add('kia-magazine-card--photo'); a.replaceChildren(photo, copy, icon('arrow'));
      } else a.replaceChildren(icon('book'), copy, icon('arrow'));
      extras.append(a);
      if(c.adapter==='prohaar')a.classList.remove('phm-row');
    }
    extras.append(panel(true)); root.insertBefore(extras, before);
  }
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(enhanceMenu); } };
  function magazineCover() {
    if (!c.magazineImage || !/^\/(?:[a-z]{2}\/)?(?:magazyn|magazine|magazin|blog|content\/category\/2-[^/]+|pages\/beauty-hair-magazine|blogs\/inspiratie)\/?$/.test(location.pathname) || document.querySelector('.kia-magazine-cover')) return;
    const heading = document.querySelector('h1');
    if (!heading) return;
    const masthead = heading.closest('.icmag-masthead,.dm-masthead,.dblog-magazine-hero,.lum-magazine__masthead,.kj-magazine-intro,.page-header,header') || heading;
    const figure = el('figure', 'kia-magazine-cover'), image = el('img');
    image.src = c.magazineImage; image.alt = c.name + ' — ' + w.magazine; image.width = 768; image.height = 512; image.decoding = 'async';
    figure.append(image);
    if (masthead.classList.contains('dblog-magazine-hero')) {
      masthead.querySelector('.dblog-magazine-scene')?.remove();
      masthead.classList.add('kia-magazine-hero'); masthead.prepend(figure);
    } else masthead.after(figure);
  }
  const start = () => {
    magazineCover();
    if (c.home) {
      const footer = document.querySelector('footer#footer,.footer-section,footer.site-footer,footer.footer,footer.shopify-section-footer');
      if (footer && !document.getElementById('kia-home-install')) {
        const box = panel(); box.id = 'kia-home-install'; const categories=document.querySelector('.ph-worlds'); if(categories)categories.after(box);else footer.before(box);
      }
    }
    enhanceMenu();
    new MutationObserver(schedule).observe(document.body, { childList:true, subtree:true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true }); else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["store-information-ticker"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (customElements.get('store-information-ticker')) return;
  class StoreInformationTicker extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.track = this.querySelector('.st-track');
      this.group = this.querySelector('.st-group');
      this.viewport = this.querySelector('.st-viewport');
      if (!this.track || !this.group || !this.viewport) return;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 767px)');
      this.hoverable = matchMedia('(hover: hover) and (pointer: fine)');
      this.hoverPause = false;
      this.focusPause = false;
      this.addEventListener('pointerenter', () => { this.hoverPause = this.hoverable.matches; this.sync(); }, { signal });
      this.addEventListener('pointerleave', () => { this.hoverPause = false; this.sync(); }, { signal });
      this.addEventListener('focusin', e => { this.focusPause = Boolean(e.target.closest('a')); if (this.focusPause && this.animation) { this.animation.currentTime = 0; } this.sync(); e.target.scrollIntoView({block:'nearest',inline:'nearest'}); }, { signal });
      this.addEventListener('focusout', () => { queueMicrotask(() => { this.focusPause = this.contains(document.activeElement) && Boolean(document.activeElement.closest('a')); this.sync(); }); }, { signal });
      this.reduced.addEventListener('change', () => this.sync(), { signal });
      this.mobile.addEventListener('change', () => this.schedule(), { signal });
      this.resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          if (entry.target === this.group) this.groupWidth = entry.contentRect.width;
          if (entry.target === this.viewport) this.viewportWidth = entry.contentRect.width;
        }
        this.schedule();
      });
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.group);
      this.contentObserver = new MutationObserver(() => this.schedule());
      this.contentObserver.observe(this.group, { childList: true, subtree: true, characterData: true });
      if (document.fonts) {
        document.fonts.ready.then(() => { if (!signal.aborted) this.schedule(); });
        document.fonts.addEventListener('loadingdone', () => this.schedule(), { signal });
      }
      this.schedule();
    }
    schedule() {
      if (!this.controller || this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.measure(); });
    }
    measure() {
      const width = this.groupWidth;
      const viewportWidth = this.viewportWidth;
      if (!width || !viewportWidth) return;
      const speed = this.mobile.matches ? 28 : 34;
      const duration = width / speed * 1000;
      const copies = Math.max(1, Math.ceil(viewportWidth / width));
      if (this.distance === width && this.speed === speed && this.copies === copies) { this.sync(); return; }
      const progress = this.animation && this.duration ? (Number(this.animation.currentTime || 0) % this.duration) / this.duration : 0;
      this.animation?.cancel();
      this.track.querySelectorAll('[data-st-copy]').forEach(node => node.remove());
      for (let i = 0; i < copies; i++) {
        const clone = this.group.cloneNode(true);
        clone.dataset.stCopy = '';
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
        clone.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(node => node.tabIndex = -1);
        this.track.append(clone);
      }
      this.distance = width;
      this.duration = duration;
      this.speed = speed;
      this.copies = copies;
      this.animation = this.track.animate([{ transform: 'translateX(0)' }, { transform: `translateX(-${width}px)` }], { duration, iterations: Infinity, easing: 'linear' });
      this.animation.currentTime = progress * duration;
      this.dataset.ready = '';
      this.sync();
    }
    sync() {
      if (!this.controller) return;
      const stopped = this.reduced.matches || this.hoverPause || this.focusPause;
      if (this.animation) stopped ? this.animation.pause() : this.animation.play();
      if (this.wasFocusPaused && !this.focusPause && !this.reduced.matches) this.viewport.scrollTo({ left: 0 });
      this.wasFocusPaused = this.focusPause;
      this.toggleAttribute('data-reduced', this.reduced.matches);
      if (this.reduced.matches && this.animation) this.animation.currentTime = 0;
      this.dataset.paused = String(stopped);
    }
    disconnectedCallback() {
      this.controller?.abort(); this.controller = null;
      this.resizeObserver?.disconnect(); this.contentObserver?.disconnect();
      this.animation?.cancel(); this.animation = null;
      cancelAnimationFrame(this.frame); this.frame = 0;
      this.track?.querySelectorAll('[data-st-copy]').forEach(node => node.remove());
      this.distance = null; this.removeAttribute('data-ready');
    }
  }
  customElements.define('store-information-ticker', StoreInformationTicker);
})();
  } catch(e) { console.error(e); }
})();

})();
